import {skipToken} from '@reduxjs/toolkit/query';
import {isFeatureEnabled} from 'feature-flags';

import {isNotNil} from 'ramda';

import {useGetCustomNoticesQuery} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';
import featureFlags from '@dms/feature-flags';
import {toMenuBadge} from '@dms/shared';

import {Nullish} from 'shared/web';

interface UseCustomNoticesBadgeParams {
  resourceId: EntityResourceIds;
  recordId: string | Nullish;
}

export function useCustomNoticesBadge(params: UseCustomNoticesBadgeParams) {
  const {data: notices} = useGetCustomNoticesQuery(
    isNotNil(params.recordId) && isFeatureEnabled(featureFlags.CUSTOM_NOTICES)
      ? {resourceId: params.resourceId, recordId: params.recordId}
      : skipToken
  );

  return {customNoticesBadge: toMenuBadge(notices?.length ?? 0)};
}
